import Vue from 'vue';
import VueRouter from 'vue-router';

import { ROUTER_MODE } from '../config/app'

import Err401 from '../views/401'
import NotFound from '../views/404.vue'
import System from '../views/System.vue'
import Login from '../views/Login.vue'
import Index from "../views/Index"
import MineInfo from "../views/mine/MineInfo"
import UserApplyList from "../views/order/UserApplyList"
import UserApplyDetail from "../views/order/UserApplyDetail"
import AddUserApply from "../views/order/AddUserApply"
import UpdateUserApply from "../views/order/UpdateUserApply"
import UserApplyMenu from "../views/order/UserApplyMenu"

Vue.use(VueRouter);

export const constantRouterMap = [
  {
    path: '/',
    component: Login,
    name: 'login',
    hidden: true,
      meta: {
          title: '员工登录',
          keepAlive: false,
      },
  },
  {
    path: '*',
    component: NotFound,
    hidden: true,
      meta: {
          title: '员工名称',
          keepAlive: false,
      },
  },
  {
    path: '/401',
    component: Err401,
    name: '401',
    hidden: true,
      meta: {
          title: '员工名称',
          keepAlive: false,
      },
  },
  {
    path: '/404',
    component: NotFound,
    name: '404',
    hidden: true,
      meta: {
          title: '员工名称',
          keepAlive: false,
      },
  },
  {
    path: '/500',
    component: NotFound,
    name: '500',
    hidden: true,
      meta: {
          title: '员工名称',
          keepAlive: false,
      },
  },
    {
        path: '/system',
        component: System,
        name: 'System',
        hidden: true,
        meta: {
            title: '系统维护',
            keepAlive: false,
        },
    },
  {
    path: '/index',
    component: Index,
    name: 'Index',
    children: [
      {
        path: '/order',
        component: UserApplyList,
          meta: {
              title: '我的休假申请',
              keepAlive: true,
          },
      },
      {
        path: '/mine',
        component: MineInfo,
          meta: {
              title: '个人信息',
              keepAlive: false,
          },
      }
    ]
  },
    {
        path: '/userApplyDetail',
        component: UserApplyDetail,
        name: 'userApplyDetail',
        meta: {
            title: '休假申请详情',
            keepAlive: false,
        },
    },
    {
        path: '/addUserApply',
        component: AddUserApply,
        name: 'addUserApply',
        meta: {
            title: '休假申请新增',
            keepAlive: false,
        },
    },
    {
        path: '/updateUserApply',
        component: UpdateUserApply,
        name: 'updateUserApply',
        meta: {
            title: '休假申请修改',
            keepAlive: false,
        },
    },
    {
        path: '/userApplyMenu',
        component: UserApplyMenu,
        name: 'UserApplyMenu',
        meta: {
            title: '休假申请选项',
            keepAlive: false,
        },
    },

];

export default new VueRouter({
  mode: ROUTER_MODE,
  routes: constantRouterMap,
  scrollBehavior: () => ({ y: 0 }),
});
